export default __webpack_public_path__ + "static/avatar-howard-cooke-a424cc908d2650de600723ba33d3f831.jpg";